"use client";
import "@repo/edtech-ui-kit/styles";
import { jsx as a, jsxs as G, Fragment as q } from "react/jsx-runtime";
import { useState as E, useRef as v, useEffect as x, useCallback as H } from "react";
import { EdtechProvider as D, useFullscreen as k } from "@repo/edtech-shared";
import { Loader as B, FullscreenButton as K } from "@repo/edtech-ui-kit";
import { AnalyticsEvent as w } from "@repo/edtech-analytics";
import { useGetScormProgress as J, useSetScormProgress as Q } from "@repo/edtech-api";
function W(e) {
  var r, s, t = "";
  if (typeof e == "string" || typeof e == "number") t += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (s = W(e[r])) && (t && (t += " "), t += s);
  } else for (s in e) e[s] && (t && (t += " "), t += s);
  return t;
}
function j() {
  for (var e, r, s = 0, t = "", o = arguments.length; s < o; s++) (e = arguments[s]) && (r = W(e)) && (t && (t += " "), t += r);
  return t;
}
const X = [
  "allow-scripts",
  "allow-same-origin",
  "allow-forms",
  "allow-popups",
  "allow-popups-to-escape-sandbox",
  "allow-downloads",
  "allow-top-navigation",
  "allow-pointer-lock"
].join(" "), $ = 3e4, V = (e) => Math.min(1, Math.max(0, e)), U = (e, r = Date.now()) => !e || r - e >= $, Y = (e, r = Date.now()) => $ - (r - (e ?? 0)), Z = (e, r = !1) => {
  (!e["cmi.completion_status"] || e["cmi.completion_status"] === "unknown") && (e["cmi.completion_status"] = r ? "completed" : "incomplete"), (!e["cmi.core.lesson_status"] || e["cmi.core.lesson_status"] === "unknown") && (e["cmi.core.lesson_status"] = r ? "completed" : "incomplete"), r && (e["cmi.completion_status"] = "completed", e["cmi.core.lesson_status"] = "completed", e["cmi.success_status"] = "passed");
  const t = !e["cmi.location"] && !e["cmi.suspend_data"] ? "" : "resume", o = r ? "normal" : "suspend";
  return t && (e["cmi.entry"] = t, e["cmi.core.entry"] = t), e["cmi.exit"] = o, e["cmi.core.exit"] = o, { payload: e };
}, ee = (e) => {
  let r = e["cmi.progress_measure"] || e["cmi.score.scaled"];
  if (!r) {
    const o = Number(e["cmi.core.score.raw"] || e["cmi.score.raw"]), u = Number(e["cmi.core.score.max"] || e["cmi.score.max"]);
    Number.isFinite(o) && Number.isFinite(u) && u > 0 && (r = String(V(o / u)));
  }
  const s = Number(r), t = Number.isFinite(s) ? V(s) : void 0;
  return {
    progressMeasure: t !== void 0 ? String(t) : void 0,
    progressNum: t
  };
}, re = (e) => {
  const r = e["cmi.completion_status"], s = e["cmi.core.lesson_status"];
  return r === "completed" || s === "completed";
}, te = (e, r, s) => s !== void 0 ? s : r !== void 0 && e !== void 0 ? e >= r ? w.Passed : w.Completed : w.Completed, F = (e, ...r) => {
  console.log(
    `%c[SCORM EVENT] ${e}`,
    "color:#4CAF50;font-weight:bold",
    ...r
  );
}, se = ({
  scormid: e,
  publicationId: r,
  unitId: s,
  onPassedScorm: t
}) => {
  const [o, u] = E({}), [f, n] = E(!1), [d, z] = E(!1), l = v({}), _ = v(!1), A = v(void 0), P = v(null), h = v(null), L = v(!1), {
    data: g,
    isLoading: I
  } = J({
    scormid: e,
    publicationid: r,
    unitid: s
  }, !!(e && r && s)), { trigger: O } = Q();
  x(() => {
    if (I || !g) return;
    const c = Number(g.currentPercent), S = Number(g.passPercent);
    if (A.current = Number.isFinite(S) ? V(S) : void 0, Number.isFinite(c) && c === 0) {
      l.current = {}, u({}), L.current = !1, P.current = null, _.current = !0, n(!0);
      return;
    }
    const N = g.payload ?? {};
    l.current = N, u(N), L.current = !0, _.current = !0, n(!0);
  }, [I, g]);
  const b = H(async (c = {}) => {
    if (!e || !r || !s) return;
    const {
      force: S = !1,
      withType: N = !0,
      explicitType: C,
      forceProgressMeasure: T
    } = c;
    if (h.current && (clearTimeout(h.current), h.current = null), !S && C === void 0 && !U(P.current)) {
      const R = Y(P.current);
      h.current = setTimeout(() => {
        b();
      }, R);
      return;
    }
    const y = structuredClone(l.current), {
      progressMeasure: m,
      progressNum: p
    } = ee(y);
    let M;
    N && (M = te(
      p,
      A.current,
      C
    )), Z(y, M === w.Passed);
    try {
      (await O({
        scorm: e,
        publicationid: r,
        unitid: s,
        progressMeasure: T ?? m ?? "0",
        type: M ?? w.Completed,
        payload: y
      })).type === w.Passed && t?.(), P.current = Date.now();
    } catch (R) {
      console.error("SCORM save failed:", R);
    }
  }, [
    t,
    r,
    e,
    O,
    s
  ]);
  return x(() => {
    if (!f) return;
    const c = window;
    c.API && delete c.API, c.API_1484_11 && delete c.API_1484_11;
    const S = (m) => {
      const p = Object.fromEntries(Object.entries(m).filter(([, R]) => R !== void 0)), M = {
        ...l.current,
        ...p
      };
      l.current = M, u(M);
    }, N = (m) => {
      const p = String(l.current[m] ?? "");
      return F(
        "GetValue",
        m,
        "=>",
        p
      ), p;
    }, C = (m, p) => (F(
      "SetValue",
      m,
      p
    ), S({ [m]: p }), (m === "cmi.completion_status" || m === "cmi.core.lesson_status") && p === "completed" && b({
      withType: !0,
      force: !0,
      forceProgressMeasure: "1"
    }), "true"), T = () => {
      F("Commit");
      const m = re(l.current);
      return b({
        withType: !0,
        force: !1,
        forceProgressMeasure: m ? "1" : void 0
      }), "true";
    }, y = () => (F("Terminate"), b({
      withType: !1,
      force: !0
    }), "true");
    return c.API_1484_11 = {
      Initialize: () => (l.current["cmi.mode"] || S({
        "cmi.mode": "normal"
      }), !L.current && g?.currentPercent === 0 && (L.current = !0, b({
        explicitType: w.Started,
        withType: !0,
        force: !0
      })), "true"),
      Terminate: y,
      GetValue: N,
      SetValue: C,
      Commit: T,
      GetLastError: () => "0",
      GetErrorString: () => "No error",
      GetDiagnostic: () => ""
    }, c.API = {
      LMSInitialize: () => (l.current["cmi.core.lesson_mode"] || S({
        "cmi.core.lesson_mode": "normal"
      }), !L.current && g?.currentPercent === 0 && (L.current = !0, b({
        explicitType: w.Started,
        withType: !0,
        force: !0
      })), "true"),
      LMSFinish: y,
      LMSGetValue: N,
      LMSSetValue: C,
      LMSCommit: T,
      LMSGetLastError: () => "0",
      LMSGetErrorString: () => "No error",
      LMSGetDiagnostic: () => ""
    }, z(!0), () => {
      h.current && (clearTimeout(h.current), h.current = null), c.API && delete c.API, c.API_1484_11 && delete c.API_1484_11;
    };
  }, [
    f,
    r,
    g?.currentPercent,
    b,
    s
  ]), {
    scormPayload: o,
    apiReady: d
  };
}, oe = "_scorm_16jzl_1", ne = "_hidden_16jzl_15", ce = "_loader_16jzl_19", ie = "_head_navigation_16jzl_28", ae = "_fullscreen_button_16jzl_39", ue = "_iframe_16jzl_43", le = "_fullscreen_16jzl_39", i = {
  scorm: oe,
  hidden: ne,
  loader: ce,
  head_navigation: ie,
  fullscreen_button: ae,
  iframe: ue,
  fullscreen: le
}, me = ({
  publicationid: e,
  unitid: r,
  scormid: s,
  file: t,
  forcefullscreen: o,
  onPassedScorm: u,
  className: f,
  onFullscreenChange: n
}) => {
  const [d, z] = E(!0), l = v(null), {
    isFullscreen: _,
    toggle: A
  } = k(l, {
    preferCssFallback: !0
  }), { apiReady: P } = se({
    scormid: s,
    publicationId: e,
    unitId: r,
    onPassedScorm: u
  });
  return x(() => {
    o && l.current && !_ && A();
  }, [
    o,
    _,
    A
  ]), x(() => {
    n && n({ isFullscreen: _ });
  }, [_, n]), /* @__PURE__ */ G(
    "div",
    {
      ref: l,
      className: j(
        i.scorm,
        f,
        (o || _) && i.fullscreen
      ),
      children: [
        (d || !P) && /* @__PURE__ */ a("div", { className: i.loader, children: /* @__PURE__ */ a(B, {}) }),
        P && /* @__PURE__ */ G(q, { children: [
          !o && !d && /* @__PURE__ */ a("div", { className: i.head_navigation, children: /* @__PURE__ */ a(
            K,
            {
              showLabel: !0,
              className: i.fullscreen_button,
              isFullscreen: _,
              onClick: A
            }
          ) }),
          /* @__PURE__ */ a(
            "iframe",
            {
              allow: "fullscreen",
              className: j(i.iframe, d && i.hidden),
              frameBorder: 0,
              sandbox: X,
              src: t,
              onLoad: () => z(!1)
            }
          )
        ] })
      ]
    }
  );
}, de = ({
  file: e,
  forcefullscreen: r,
  className: s,
  onFullscreenChange: t
}) => {
  const [o, u] = E(!0), f = v(null), {
    isFullscreen: n,
    toggle: d
  } = k(f, {
    preferCssFallback: !0
  });
  return x(() => {
    r && f.current && !n && d();
  }, [
    r,
    n,
    d
  ]), x(() => {
    t && t({ isFullscreen: n });
  }, [n, t]), /* @__PURE__ */ G(
    "div",
    {
      ref: f,
      className: j(
        i.scorm,
        s,
        (r || n) && i.fullscreen
      ),
      children: [
        o && /* @__PURE__ */ a("div", { className: i.loader, children: /* @__PURE__ */ a(B, {}) }),
        !r && !o && /* @__PURE__ */ a("div", { className: i.head_navigation, children: /* @__PURE__ */ a(
          K,
          {
            showLabel: !0,
            className: i.fullscreen_button,
            isFullscreen: n,
            onClick: d
          }
        ) }),
        /* @__PURE__ */ a(
          "iframe",
          {
            allow: "fullscreen",
            className: j(i.iframe, o && i.hidden),
            frameBorder: 0,
            sandbox: X,
            src: e,
            onLoad: () => u(!1)
          }
        )
      ]
    }
  );
}, Pe = ({
  publicationid: e,
  unitid: r,
  scormid: s,
  file: t,
  forcefullscreen: o = !1,
  onPassedScorm: u,
  className: f,
  withScormApi: n = !0,
  onFullscreenChange: d
}) => n ? /* @__PURE__ */ a(D, { name: "scorm-player", children: /* @__PURE__ */ a(
  me,
  {
    className: f,
    file: t,
    forcefullscreen: o,
    publicationid: e,
    scormid: s,
    unitid: r,
    onFullscreenChange: d,
    onPassedScorm: u
  }
) }) : /* @__PURE__ */ a(D, { name: "scorm-player", children: /* @__PURE__ */ a(
  de,
  {
    className: f,
    file: t,
    forcefullscreen: o,
    onFullscreenChange: d
  }
) });
export {
  Pe as EdtechScormPlayer
};
